import { UserCancellationInterceptOutcomeTotalInterface } from "@vendor-app/domain/UserCancellationInterceptOutcomeTotalInterface";

import { UserCancellationInterceptOutcomeTotalsMapperInterface } from "./interface";

export class UserCancellationInterceptOutcomeTotalsMapper
  implements UserCancellationInterceptOutcomeTotalsMapperInterface
{
  public mapData(data: any[]): UserCancellationInterceptOutcomeTotalInterface[] {
    const totals = data.map(
      mappedTotal =>
        ({
          outcome: mappedTotal.outcome,
          count: mappedTotal.count,
        }) as UserCancellationInterceptOutcomeTotalInterface
    );

    return totals;
  }
}
